import Vue from 'vue'
import VLoading from '@components/loading.vue'
import axios from 'axios'
const el = document.querySelector('#cc-signup')
if (el != null) {
  var vm = new Vue({
    components: {
      VLoading
    },
    data: () => {
      return {
        submitted: false,
        loading: false,
        error: null
      }
    },
    delimiters: ['[[', ']]'],
    methods: {
      async signup () {
        this.loading = true
        this.error = null
        const formData = new FormData(this.$el) // reference to form element
        const data = {} // need to convert it before using not with XMLHttpRequest
        for (const [key, val] of formData.entries()) {
          Object.assign(data, { [key]: val })
        }
        axios.post('actions/' + data.action, data)
          .then(res => {
            const obj = JSON.parse(res.request.response)
            if (obj.success) {
              this.submitted = true
            } else if (obj.message) {
              this.error = obj.message
            } else {
              this.error = 'An unknown error occurred'
            }
          })
        await this.wait(500)
        this.loading = false
      },
      wait (ms) {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve('resolved')
          }, ms)
        })
      }
    },
    computed: {},
    beforeMount () {}
  })
  vm.$mount(el)
}
